import { performances, categories } from "@/data/performances";
import { OfferCard } from "./OfferCard";
import { useState } from "react";
import { motion } from "framer-motion";

export const Offer = () => {
  const [activeCategory, setActiveCategory] = useState<string | null>(null);

  const filteredCategories = activeCategory
    ? categories.filter(c => c.slug === activeCategory)
    : categories;

  return (
    <section id="offer" className="py-24 bg-primary relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: "linear-gradient(rgba(255,255,255,.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.1) 1px, transparent 1px)",
        backgroundSize: "40px 40px"
      }} />

      <div className="container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-6"
        >
          <span className="text-accent font-semibold text-sm tracking-widest uppercase">Co oferujemy</span>
          <h2 className="text-4xl md:text-5xl font-montserrat font-bold mt-3 text-white">
            Nasza Oferta
          </h2>
          <p className="text-white/60 mt-4 text-lg max-w-2xl mx-auto">
            Wybierz idealny występ na swoje wydarzenie
          </p>
        </motion.div>

        {/* Category filter pills */}
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
          className="flex flex-wrap justify-center gap-2 mb-16"
        >
          <button
            onClick={() => setActiveCategory(null)}
            className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
              activeCategory === null
                ? "bg-accent text-white shadow-lg shadow-accent/25"
                : "bg-white/5 border border-white/10 text-white/60 hover:text-white hover:bg-white/10"
            }`}
          >
            Wszystkie
          </button>
          {categories.map((cat) => (
            <button
              key={cat.slug}
              onClick={() => setActiveCategory(activeCategory === cat.slug ? null : cat.slug)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-300 ${
                activeCategory === cat.slug
                  ? "bg-accent text-white shadow-lg shadow-accent/25"
                  : "bg-white/5 border border-white/10 text-white/60 hover:text-white hover:bg-white/10"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </motion.div>

        {/* Category sections */}
        <div className="space-y-16">
          {filteredCategories.map((category) => {
            const categoryPerformances = performances.filter(p => p.category === category.slug);
            if (categoryPerformances.length === 0) return null;

            return (
              <motion.div
                key={category.slug}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                <div className="mb-6">
                  <h3 className="text-2xl font-montserrat font-bold text-white">
                    {category.name}
                  </h3>
                  <p className="text-white/50 mt-1">{category.description}</p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
                  {categoryPerformances.map((performance, i) => (
                    <motion.div
                      key={performance.slug}
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.3, delay: 0.03 * i }}
                    >
                      <OfferCard performance={performance} />
                    </motion.div>
                  ))}
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
